import { render } from "./PlanDetails.vue?vue&type=template&id=21d8c7d4&scoped=true"
import script from "./PlanDetails.vue?vue&type=script&lang=js"
export * from "./PlanDetails.vue?vue&type=script&lang=js"

import "./PlanDetails.vue?vue&type=style&index=0&id=21d8c7d4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d8c7d4"]])

export default __exports__